import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  gap: 14px;
  align-items: flex-start;
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: ${(p) => p.theme.tokens.radii.lg}px;
  padding: 14px;
  border: 1px solid ${(p) => p.theme.tokens.colors.line};
  box-shadow: ${(p) => p.theme.tokens.shadows.card};
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  font-family: ${(p) => p.theme.tokens.font.family};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${(p) => p.theme.tokens.shadows.floating};
  }
`;

export const ThumbWrap = styled.div`
  position: relative;
  width: 96px;
  height: 96px;
  flex-shrink: 0;
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
  padding-top: 2px;
`;

export const Title = styled.div`
  font-weight: 800;
  font-size: 15.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
  letter-spacing: -0.2px;
`;

export const Description = styled.div`
  font-size: 13px;
  color: ${(p) => p.theme.tokens.colors.muted};
  line-height: 1.4;
  margin-top: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Footer = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Price = styled.span`
  font-weight: 900;
  font-size: 15.5px;
  color: ${(p) => p.theme.tokens.colors.teal};
`;

export const OldPrice = styled.span`
  font-size: 11px;
  color: ${(p) => p.theme.tokens.colors.muted};
  text-decoration: line-through;
`;

export const ActionPill = styled.button<{ $active: boolean }>`
  flex-shrink: 0;
  border: none;
  border-radius: 999px;
  padding: 8px 14px;
  font-weight: 800;
  font-size: 12.5px;
  font-family: ${(p) => p.theme.tokens.font.family};
  cursor: pointer;
  background: ${(p) => (p.$active ? p.theme.tokens.gradients.accent : p.theme.tokens.gradients.button)};
  color: ${(p) => p.theme.tokens.colors.surface};
  -webkit-tap-highlight-color: transparent;
`;

export const ChevronWrap = styled.div`
  flex-shrink: 0;
  align-self: center;
  color: ${(p) => p.theme.tokens.colors.muted};
`;
